import debug from "debug";
import * as THREE from "three";

const log = debug("app:cameraswap");

class alignPlane {
    private experience: any;
    private camera: THREE.PerspectiveCamera;
    private controls: any;
    private scene: THREE.Scene;
    private eventHub: any;
    private defaultCameraState: {
        position: THREE.Vector3;
        target: THREE.Vector3;
        up: THREE.Vector3;
        near: number;
        far: number;
        zoom: number;
    };

    constructor(experience: any) {
    this.experience = experience;
    this.camera = experience.camera.instance;
    this.controls = experience.camera.controls;
    this.scene = experience.scene;
    this.eventHub = this.experience.eventHub;
    this.defaultCameraState = this.storeCameraState();

    log("Controls:", this.controls);
        this.initListeners();
    }

    private initListeners() {
        this.eventHub.on("alignPlane", () => this.alignPlane());
    }

    private alignPlane() {
            log("Aligning plane using orbit rotation");
    
            const originalTarget = this.controls.target.clone();
            const distance = this.camera.position.distanceTo(originalTarget);
    
            // Determine new orbit direction (top-down or bottom-up)
            let newDirection = new THREE.Vector3(0, 1, 0);
            
            if (this.camera.position.y < originalTarget.y) {
                newDirection.set(0, -1, 0);
                this.eventHub.emit("viewChange", "bottom");
            } else{
                this.eventHub.emit("viewChange", "top");
            }
    
            // Compute new camera position using the locked orbit distance
            const newCameraPos = new THREE.Vector3().copy(originalTarget).addScaledVector(newDirection, distance);
    
            // Apply the new camera position
            this.camera.position.copy(newCameraPos);
    
            // Lock the OrbitControls target to prevent drift
            this.controls.target.copy(originalTarget);
            this.controls.enableDamping = false;
            this.controls.dampingFactor = 0; 
    
            // Ensure the camera up vector is set correctly
            this.camera.up.set(0, 1, 0);
    
            // Force OrbitControls to immediately snap into place
            this.controls.update();
    
            log("Align complete: Camera now precisely orbits the object.");
        }
    
        storeCameraState() {
            return {
                position: this.camera.position.clone(),
                target: this.controls.target.clone(),
                up: this.camera.up.clone(),
                near: this.camera.near,
                far: this.camera.far,
                zoom: this.camera.zoom
            };
        }
    
        restoreCameraState() {
            this.camera.position.copy(this.defaultCameraState.position);
            this.controls.target.copy(this.defaultCameraState.target);
            this.camera.up.copy(this.defaultCameraState.up);
            this.camera.near = this.defaultCameraState.near;
            this.camera.far = this.defaultCameraState.far;
            this.camera.zoom = this.defaultCameraState.zoom;
            this.camera.updateProjectionMatrix();
            this.controls.update();
        }
    
        resetToDefaultCamera() {
            this.camera.position.set(0, 200, 0);
            this.camera.lookAt(0, 0, 0);
            this.camera.up.set(0, 1, 0);
            this.camera.near = 0.1;
            this.camera.far = 10000;
            this.camera.updateProjectionMatrix();
            this.controls.target.set(0, 0, 0);
            this.controls.update();
        }
}

export default alignPlane;